<template>
    <div class="flex flex-col h-full">
        <div class="grid grid-cols-12 gap-y-2">
            <template v-for="message in messages">
                <div v-if="!message.is_sender" :key="message.id" class="col-start-1 col-end-8 p-3 rounded-lg">
                    <div class="flex flex-row items-center">
                        <button
                            class="relative z-10 block h-12 w-12 rounded-full overflow-hidden border-2 border-teal-500 focus:outline-none focus:border-gray-300"
                        >
                            <user-avatar :avatar-url="message.sender.avatar_url" :username="message.sender.name"></user-avatar>
                        </button>
                        <div
                            class="relative ml-2 mt-4 text-sm bg-white py-2 px-4 shadow rounded-xl rounded-b-lg rounded-r-lg"
                            style="max-width: 90%"
                        >
                            <div class="pre-formatted">{{ message.body }}</div>
                        </div>
                    </div>
                </div>
                <div v-if="message.is_sender" :key="message.id" class="col-start-6 col-end-13 p-3 rounded-lg">
                    <div class="flex items-center justify-start flex-row-reverse">
                        <div class="relative mr-3 text-sm bg-indigo-100 py-2 px-4 shadow rounded-xl rounded-l-lg rounded-b-lg">
                            <div class="pre-formatted">{{ message.body }}</div>
                        </div>
                    </div>
                </div>
            </template>
        </div>
    </div>
</template>

<script>
export default {
    props: {
        messages: {
            type: Array,
            required: true
        }
    }
};
</script>
<style scoped>
.pre-formatted {
    white-space: pre-wrap;
}
</style>
